module.exports = __webpack_public_path__ + "img/proapp-3.923c62b3.jpg";